<div *ngIf="IsSelected" class="tab" [style.height]="TabHeaderHeight">
    <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/tab/tab.html